import { getColor } from 'utils/color';

/**
 * Converts the Parabo color to the CSS 3 color.
 * Parabo color uses the less common #RRGGBBAA format defined in CSS 4.
 * For the sake of compatibility the CSS 3 rgba() output format is used.
 *
 * Sources:
 * - https://www.w3.org/TR/css-color-3/#rgba-color
 * - https://www.w3.org/TR/css-color-4/#hex-notation
 * @param {string} color Color in #RRGGBB or #RRGGBBAA format.
 * @returns {string} Color in rgb() or rgba() format.
 */
const convertColorToCss = color => {
  return getColor(color).toRgbString();
};

export default convertColorToCss;
